// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-check .form-check-input[data-v-674415ce]{float:none}.form-check-input[data-v-674415ce]{margin-right:1%}.form-check-input[data-v-674415ce]:checked{background-color:#606467;border-color:#606467}", ""]);
// Exports
module.exports = exports;
